import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { Member } from "../../../types/member.types";
import { Paycheck } from "../../../types/paycheck.types";
import { request } from "../api";

const initialRoute = "user";
const { get } = request;

export const getMemberAndPaycheck = async (
	_id: string,
	token: string
): Promise<{ member: Member; paycheck: Paycheck }> => {
	try {
		const endpoint = `${initialRoute}/member-paycehck`;
		const params = {
			_id
		};
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			params
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const getMember = async (_id: string): Promise<Member> => {
	try {
		const endpoint = `${initialRoute}/member/${_id}`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			...headers,
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const user = {
	getMemberAndPaycheck,
	getMember
};
